// extracted by mini-css-extract-plugin
module.exports = {"admin-container":"Admin_admin-container__2u7Wl","admin-nav":"Admin_admin-nav__3uesh"};